import React, { useState, useEffect } from "react";

import "./App.css";
import Countries from "./Components/Countries";
import Search from "./Search";

const App = () => {
  const url = "https://restcountries.com/v3.1/all";
  const [isLoading, setisLoading] = useState(true);
  const [error, setError] = useState(null);
  const [countries, setCountries] = useState([]);
  const [filteredCountries, setfilteredCountries] = useState(countries);

  const fetchData = async (url) => {
    setisLoading(true);
    try {
      const res = await fetch(url);
      const data = await res.json();
      setCountries(data);
      setfilteredCountries(data);
      setisLoading(false);
      setError(null);
    } catch (e) {
      setisLoading(false);
      setError(e.message);
    }
  };
  useEffect(() => {
    fetchData(url);
  }, []);
  const handleRemoveCountry = (name) => {
    const filter = filteredCountries.filter(
      (country) => country.name.common != name
    );
    setfilteredCountries(filter);
  };
  const handleSearch = (searchValue) => {
    let value = searchValue.toLowerCase();
    const newCountries = countries.filter((country) => {
      const countryName = country.name.common.toLowerCase();
      return countryName.startsWith(value);
    });
    setfilteredCountries(newCountries);
  };
  return (
    <div>
      <h1>Country App</h1>
      <Search onSearch={handleSearch} />
      {isLoading && <h4>Loading...</h4>}
      {error && <h4>{error.message}</h4>}
      {countries && (
        <Countries
          countries={filteredCountries}
          onRemoveCountry={handleRemoveCountry}
        />
      )}
    </div>
  );
};

export default App;
